import * as React from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import NavBar from "../../components/NavBar";
import {Cancel, Instagram, Phone, Telegram} from '@mui/icons-material';
import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";
import {useDispatch, useSelector} from "react-redux";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {setLoading} from "../../redux/loading/actions";
import {Box, CircularProgress} from "@mui/material";
import {handleBorderColor, HandleValidationMethod, removeNonNumeric, useShowMessageComponent} from "../../assets/js/main";
import HandleFetchData from "../../plugin/HandleFetchData";
import {setValidations} from "../../redux/public/actions";
import LinkIcon from "@mui/icons-material/Link";
import BottomNavigation from "../../components/BottomNavigation";

export default function Ticket() {
  const {t} = useTranslation()
  const location = useLocation();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const {fetchData} = HandleFetchData()
  const {showMessageComponent} = useShowMessageComponent()
  const {validationMethod} = HandleValidationMethod()

  const subjectRef = React.useRef()
  const priorityRef = React.useRef()
  const departmentRef = React.useRef()
  const ticketTypeRef = React.useRef()
  const orderCodeRef = React.useRef()
  const trackingCodeRef = React.useRef()
  const descriptionRef = React.useRef()

  const navigate = useNavigate();
  const [subject, setSubject] = React.useState("");
  const [orderCode, setOrderCode] = React.useState("");
  const [trackingCode, setTrackingCode] = React.useState("");
  const [priority, setPriority] = React.useState('');
  const [department, setDepartment] = React.useState('');
  const [ticketType, setTicketType] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [img, setImg] = React.useState([]);
  const [ticketCategory, setTicketCategory] = React.useState([]);
  const [ticketDepatment, setTicketDepatment] = React.useState([]);
  const [ticketPrority, setTicketPrority] = React.useState([]);

  const userInfo = JSON.parse(localStorage.getItem('info-user'))

  React.useEffect(() => {
    getTicketBaseData()
  }, [])

  const handlerValidations = () => {
    if (!subject) {
      validationMethod(subjectRef, "subject_validations", t("error.t36"))
    } else if (!priority) {
      validationMethod(priorityRef, "priority_validations", t("error.t37"))
    } else if (!department) {
      validationMethod(departmentRef, "department_validations", t("error.t38"))
    } else if (!ticketType) {
      validationMethod(ticketTypeRef, "ticketType_validations", t("error.t39"))
    }
    // else if (department === 3 && !orderCode) {
    //   validationMethod(orderCodeRef, "orderCode_validations", t("error.t40"))
    // } else if (department === 3 && !trackingCode) {
    //   validationMethod(trackingCodeRef, "trackingCode_validations", t("error.t41"))
    // }
    else if (!description) {
      validationMethod(descriptionRef, "description_validations", t("error.t42"))
    } else {
      sendTicket()
    }
  }

  const sendTicket = async (e) => {
    dispatch(setLoading(true))
    dispatch(setValidations(null))
    let fetch = await fetchData('ticketing', 'POST', '/v1/Ticket',
        {
          "contact": {
            "contactName": userInfo?.FullName,
            "description": "",
            "email": userInfo?.Email,
            "phone": userInfo?.Mobile
          },
          "ticket": {
            "ticketSourceCode": "postex",
            "ticketName": subject,
            "orderNo": Number(orderCode),
            "trackingCode": trackingCode,
            "ticketType": Number(ticketType),
            "ticketPriority": Number(priority)
          },
          "comment": {
            "supportAgentName": "",
            "commentText": description,
            "ticketStatus": 0
          },
          "assignment": {
            "organizationId": Number(department)
          },
          "files": img,
        },
        "application/json", '', "postex", "HiCMSPostexAdmin@1402"
    )
    // setItems_Invoices(fetch)
    if (fetch?.success) {
      showMessageComponent(fetch && fetch?.message, 'success')
      navigate({
        pathname: "/support/list",
        search: location?.search
      });
    } else if (fetch && fetch?.status == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    } else {
      showMessageComponent(fetch && fetch?.message, 'error')
    }
    dispatch(setLoading(false))
  }

  const getTicketBaseData = async (e) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('ticketing', 'GET', `/v1/TicketData`, '',
        "application/json", '', 'postex', "HiCMSPostexAdmin@1402"
    )

    if (fetch?.success) {
      setTicketCategory(fetch?.data?.ticketTypes)
      setTicketDepatment(fetch?.data?.ticketOrganizations)
      setTicketPrority(fetch?.data?.ticketProrities)

    } else {
      showMessageComponent(fetch?.response && fetch?.response?.data?.message || '', 'error')
    }
    dispatch(setLoading(false))
  }

  function onImageChange(event) {
    const reader = new FileReader()
    reader.readAsDataURL(event.target.files[0])
    reader.onload = () => {
      setImg([...img, reader.result])
    }
  }

  function removeIMG(i) {
    var item = [...img]; // make a separate copy of the array
    item.splice(i, 1);
    setImg(item)
  }

  return (
      <>
        <NavBar blue back/>

        <div className="container">
          <div className="ticketPage desktopSection bgDesktopPage">
            <h4 className="titleSection">{t("sendTicket.t1")}</h4>
            <p className="description">
              {t("sendTicket.t2")} <Link to={{pathname: '/faq', search: location?.search}}> {t("sendTicket.t3")} </Link>
              {t("sendTicket.t4")}
            </p>

            <div className="bodyPage">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <label className="required">{t("sendTicket.t5")}</label>
                  <input type="text" name="subject" value={subject} ref={subjectRef}
                         style={handleBorderColor(selector?.public?.validations?.subject_validations)}
                         onChange={(event) => setSubject(event.target.value)} id="subject"/>

                  {
                      selector?.public?.validations?.subject_validations &&
                      <p className="error">{selector?.public?.validations?.subject_validations}</p>
                  }
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <label className="required">{t("sendTicket.t11")}</label>
                  <Select
                      id="priority"
                      ref={priorityRef}
                      value={priority}
                      style={handleBorderColor(selector?.public?.validations?.priority_validations)}
                      onChange={(event) => setPriority(event.target.value)}
                      displayEmpty
                      inputProps={{'aria-label': 'Without label'}}
                  >
                    {
                      ticketPrority?.map(item => {
                        return <MenuItem value={item?.code} key={item?.code}>{item?.title}</MenuItem>
                      })
                    }
                  </Select>
                  {
                      selector?.public?.validations?.priority_validations &&
                      <p className="error">{selector?.public?.validations?.priority_validations}</p>
                  }
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <label className="required">{t("sendTicket.t37")}</label>
                  <Select
                      id="department"
                      ref={departmentRef}
                      value={department}
                      style={handleBorderColor(selector?.public?.validations?.department_validations)}
                      onChange={(event) => setDepartment(event.target.value)}
                      displayEmpty
                      inputProps={{'aria-label': 'Without label'}}
                  >
                    {
                      ticketDepatment?.map(item => {
                        return <MenuItem value={item?.code} key={item?.code}>{item?.title}</MenuItem>
                      })
                    }
                  </Select>
                  {
                      selector?.public?.validations?.department_validations &&
                      <p className="error">{selector?.public?.validations?.department_validations}</p>
                  }
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <label className="required">{t("sendTicket.t38")}</label>
                  <Select
                      id="ticketType"
                      ref={ticketTypeRef}
                      value={ticketType}
                      style={handleBorderColor(selector?.public?.validations?.ticketType_validations)}
                      onChange={(event) => {
                        setTicketType(event.target.value)
                        event.target.value === 4 && setImg([])
                      }}
                      displayEmpty
                      inputProps={{'aria-label': 'Without label'}}
                  >
                    {
                      ticketCategory?.map(item => {
                        return <MenuItem value={item?.code} key={item?.code}>{item?.title}</MenuItem>
                      })
                    }
                  </Select>
                  {
                      selector?.public?.validations?.ticketType_validations &&
                      <p className="error">{selector?.public?.validations?.ticketType_validations}</p>
                  }
                </div>

                {
                    ticketType !== 4 &&
                    <>
                      <div className="col-12 col-md-6 col-lg-4">
                        {/*<label className={department === 3 ? "required" : ""}>{t("sendTicket.t9")}</label>*/}
                        <label>{t("sendTicket.t9")}</label>
                        <input type="text" name="orderCode" className="numeric" value={orderCode}
                               style={handleBorderColor(selector?.public?.validations?.orderCode_validations)}
                               ref={orderCodeRef}
                               onChange={(e) => e.target.value.length <= 7 && setOrderCode(removeNonNumeric(e?.target.value))}
                               id="orderCode"/>

                        {
                            selector?.public?.validations?.orderCode_validations &&
                            <p className="error">{selector?.public?.validations?.orderCode_validations}</p>
                        }
                      </div>

                      <div className="col-12 col-md-6 col-lg-4">
                        {/*<label className={department === 3 ? "required" : ""}>{t("sendTicket.t10")}</label>*/}
                        <label>{t("sendTicket.t10")}</label>
                        <input type="text" name="trackingCode" className="numeric" ref={trackingCodeRef}
                               style={handleBorderColor(selector?.public?.validations?.trackingCode_validations)}
                               value={trackingCode}
                               onChange={(e) => e.target.value.length <= 24 && setTrackingCode(removeNonNumeric(e?.target.value))}
                               id="trackingCode"/>

                        {
                            selector?.public?.validations?.trackingCode_validations &&
                            <p className="error">{selector?.public?.validations?.trackingCode_validations}</p>
                        }
                      </div>
                    </>
                }


                <div className="col-12">
                  <label className="required">{t("sendTicket.t12")}</label>
                  <textarea rows="3" name="description" value={description} ref={descriptionRef}
                            style={handleBorderColor(selector?.public?.validations?.description_validations)}
                            onChange={(e) => setDescription(e?.target.value)} id="description"/>
                  {
                      selector?.public?.validations?.description_validations &&
                      <p className="error">{selector?.public?.validations?.description_validations}</p>
                  }
                </div>


              </div>

              {subject != 1 &&
                  <div className="selectIMG">
                    <div>
                      {
                          (ticketType == 4 ? img.length <= 0 : img.length < 3) &&
                          <button className="selectIMG">
                            <label htmlFor="upload-photo">{t("sendTicket.t31")}</label>
                            <input type="file" name="photo" id="upload-photo" onChange={onImageChange}/>
                          </button>
                      }
                      {ticketType !== 4 && <p>{t("sendTicket.t32")}</p>}
                    </div>
                    <div className="row listIMG">
                      {
                        img.map((item, index) => <div className="col-6 col-lg-3" key={index}>
                              <button onClick={() => removeIMG(index)} id="removeIMG"><Cancel/></button>
                              <img src={item} alt="img" loading="lazy"/>
                            </div>
                        )
                      }
                    </div>
                  </div>
              }

            </div>

            <div className="row">
              <div className="col-12 col-md-8">
                {/*<Captcha />*/}
              </div>
              <div className="col-12 col-md-4">
                <div className="_btnGroup_yellow m-0">
                  <button className="btnFill" onClick={handlerValidations} id="handlerValidations">
                    {
                      selector?.loading?.isLoading ?
                          <Box sx={{display: 'flex'}}>
                            <CircularProgress size={20}/>
                          </Box>
                          :
                          <span>{t("sendTicket.t33")}</span>
                    }

                  </button>
                </div>
              </div>
            </div>


            <div className="row mt-4">
              <hr/>

              <div className="col-12 col-xl-4">
                <h2>{t("about.t8")}</h2>
              </div>

              <div className="col-6 col-md-6 col-lg-3 col-xl-2">
                <div className="item-social">
                  <a href="https://t.me/postex" target="_blank" id="telegram">t.me/postex</a>
                  <div className="item">
                    <Telegram/>
                  </div>
                </div>
              </div>
              <div className="col-6 col-md-6 col-lg-3 col-xl-2">
                <div className="item-social">
                  <a href="https://instagram.com/postex.ir" target="_blank" id="instagram">postex.ir</a>
                  <div className="item">
                    <Instagram/>
                  </div>
                </div>
              </div>
              <div className="col-6 col-md-6 col-lg-3 col-xl-2">
                <div className="item-social">
                  <a href="https://www.postex.ir" id="postex">postex.ir</a>
                  <div className="item">
                    <LinkIcon/>
                  </div>
                </div>
              </div>
              <div className="col-6 col-md-6 col-lg-3 col-xl-2">
                <div className="item-social">
                  <a href="tel:02191300250" id="phone">02191300250</a>
                  <div className="item">
                    <Phone/>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>

        <div className="d-block d-lg-none">
          <BottomNavigation/>
        </div>
      </>
  )
}
